import { Item } from "dsabp-js"
import { createCanvas } from "../canvas.js"
import { rendererResolvers } from "../main.js"
import { getImage, getTinted, toImage } from "../util.js"

rendererResolvers.push(
	({ item }) => {
		if (item != Item.DOOR)
			return

		return {
			discriminator: `${item.id}`,
			async render() {
				const img = await getTinted(getImage(item.buildInfo[0].image), "#ababab")

				const canvas = createCanvas(img.width, img.height)
				canvas.getContext("2d").drawImage(img, 0, 0)

				return [{
					image: await toImage(canvas),
					textureSizeOff: { x: 0.55, y: 0 },
					texturePosOff: { x: -0.275, y: 0 }
				}]
			}
		}
	}
)
